import { t } from "@lingui/macro";
import { format, parse } from "date-fns";

import { Button } from "@whoosh/design-system/src/components/controls";
import { VStack, Text } from "@whoosh/design-system/src/components/primitive";

type Props = {
  onPress: () => void;
  dateString: string;
};

export const SelectDateButton = ({ dateString, onPress }: Props) => {
  const date = parse(dateString, "yyyy-MM-dd", new Date());
  const formatted = date ? format(date, "d,EEE") : null;
  const [dayOfMonth, dayOfWeek] = formatted ? formatted.split(",") : ["", ""];

  return (
    <Button
      onPress={onPress}
      testID="mobile-header-date-button"
      accessibilityLabel={t`Select date`}
    >
      <VStack alignItems="center" minWidth={24}>
        <Text
          maxFontSizeMultiplier={2}
          color="text-inverse"
          variant="mainMicro"
        >
          {dayOfWeek}
        </Text>
        <Text
          maxFontSizeMultiplier={2}
          color="text-inverse"
          variant="mainHeading"
        >
          {dayOfMonth}
        </Text>
      </VStack>
    </Button>
  );
};
